'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _prop2 = require('ramda/src/prop');

var _prop3 = _interopRequireDefault(_prop2);

var _templateObject = _taggedTemplateLiteral(['\n    width: 100%;\n    border-radius: 20px;\n    background: #f5f5f5;\n    margin-bottom: 15px;\n'], ['\n    width: 100%;\n    border-radius: 20px;\n    background: #f5f5f5;\n    margin-bottom: 15px;\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n    height: 8px;\n    border-radius: 20px;\n    background: #1890ff;\n    width: ', '%;\n    transition: all .4s cubic-bezier(.08,.82,.17,1) 0s;\n'], ['\n    height: 8px;\n    border-radius: 20px;\n    background: #1890ff;\n    width: ', '%;\n    transition: all .4s cubic-bezier(.08,.82,.17,1) 0s;\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Container = _styledComponents2.default.div(_templateObject);

var Bar = _styledComponents2.default.div(_templateObject2, (0, _prop3.default)('progress'));

var Progress = function Progress(_ref) {
    var progress = _ref.progress;
    return _react2.default.createElement(
        Container,
        null,
        _react2.default.createElement(Bar, { progress: progress })
    );
};

Progress.propTypes = {
    progress: _propTypes2.default.number
};

exports.default = Progress;